module.exports = ".form-heading{color:#a0a0a0}.form-spinner{float:right}button{margin-right:8px}"